<template>
  <div class="expert_report w_d fff">
    <h2 class="title_com">专家报告</h2>
    <section class="pd2430">
      <!-- 基本数据 -->
      <h2 class="fs20 mb20">基本数据</h2>
      <el-row class="mb20 border bdr4" style="font-size: 14px; padding: 20px">
        <el-col :span="6">
          <section class="col-height">
            专家：<span class="recommend-label">{{
              baseData.expert_count
            }}</span>
          </section>
        </el-col>
        <el-col :span="6">
          <section class="col-height">
            面授课：<span class="recommend-label">{{
              baseData.face_count
            }}</span>
          </section>
        </el-col>
        <el-col :span="5">
          <section class="col-height">
            总学时：<span class="recommend-label">{{
              baseData.class_time
            }}</span>
          </section>
        </el-col>
        <el-col :span="7">
          <section class="col-height">
            专家平均满意度：<span class="recommend-label"
              >{{ baseData.expert_avg_ok }}%</span
            >
          </section>
        </el-col>
      </el-row>
      <!-- 专家满意度统计 -->
      <div class="satisfaction my_flex">
        <h2 class="fs20">专家满意度统计</h2>
        <div class="two_btn">
          <el-button type="primary" size="mini" @click="customExpertAdd()"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="handleAvgExport"
            >导出</el-button
          >
        </div>
      </div>
      <!-- 专家满意度统计表格 -->
      <el-table
        :data="expertAvgList"
        :header-cell-style="{
          background: '#F0F0F0',
          fontSize: '14px',
          height: '50px',
          fontWeight: 500,
          color: '#333',
        }"
        class="mgtb20"
      >
        <el-table-column label="序号" align="center" type="index" />
        <div v-for="(aitem, aindex) in expertAvgHeader" :key="aindex">
          <el-table-column
            :label="aitem.c_name"
            align="center"
            :prop="aitem.name"
            show-overflow-tooltip
          />
        </div>
        <el-table-column
          label="操作"
          align="center"
          width="1px"
        ></el-table-column>
      </el-table>
      <!-- 专家满意度明细 -->
      <!-- <h2 class="fs20">专家满意度明细</h2> -->
      <div class="satisfaction my_flex">
        <h2 class="fs20">专家满意度明细</h2>
        <div class="two_btn" v-if="expertArr.length !== 0">
          <el-button type="primary" size="mini" @click="customAdd()"
            >自定义表头</el-button
          >
          <el-button type="primary" size="mini" @click="handleExport"
            >导出选择题明细</el-button
          >
        </div>
      </div>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane
          :label="eitem.username"
          :name="eitem.idnum"
          v-for="(eitem, eindex) in expertArr"
          :key="eindex"
        >
          <el-row
            class="mb20 border-solid-color"
            style="font-size: 14px; padding: 20px 0"
          >
            <el-col :span="3">
              <section class="col-height">
                姓名：<span class="recommend-label">{{
                  userData.username
                }}</span>
              </section>
            </el-col>
            <el-col :span="4">
              <!-- 提示 -->
              <el-tooltip placement="top" popper-class="face_list">
                <div slot="content">
                  <el-table
                    :header-cell-style="{
                      background: '#F0F0F0',
                      fontSize: '14px',
                      height: '50px',
                      fontWeight: 500,
                      color: '#333',
                    }"
                    :data="faceList"
                  >
                    <el-table-column label="ID" align="center" prop="id" />
                    <el-table-column
                      label="标题"
                      align="center"
                      show-overflow-tooltip
                      width="180"
                      prop="title"
                    />
                    <el-table-column label="时间" align="center" width="200">
                      <template slot-scope="{ row }">
                        <span>
                          {{ row.start_date | filterYMD }} ~
                          {{ row.end_date | filterYMD }}
                        </span>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <section class="col-height">
                  本班所教面授课：<span class="recommend-label">{{
                    userData.face_count
                  }}</span>
                </section>
              </el-tooltip>
            </el-col>

            <el-col :span="3">
              <section class="col-height">
                参评人次：<span class="recommend-label">{{
                  userData.staff_num
                }}</span>
              </section>
            </el-col>
            <el-col :span="3">
              <section class="col-height">
                满意：<span class="recommend-label"
                  >{{ userData.satisfy }}%</span
                >
              </section>
            </el-col>
            <el-col :span="3">
              <section class="col-height">
                一般：<span class="recommend-label"
                  >{{ userData.common }}%</span
                >
              </section>
            </el-col>
            <el-col :span="3">
              <section class="col-height">
                不满意：<span class="recommend-label"
                  >{{ userData.dissatisfied }}%</span
                >
              </section>
            </el-col>

            <el-col :span="5">
              <section
                class="col-height"
                style="float: right; margin-right: 40px"
              >
                <strong>整体满意度：</strong
                ><span class="recommend-label">{{ userData.whole }}%</span>
              </section>
            </el-col>
          </el-row>
          <!-- 表格 -->

          <el-table
            :header-cell-style="{
              background: '#F0F0F0',
              fontSize: '14px',
              height: '50px',
              fontWeight: 500,
              color: '#333',
            }"
            class="mgtb20"
            :data="postList"
          >
            <el-table-column label="序号" align="center" type="index" />
            <div v-for="(aitem, aindex) in headerList" :key="aindex">
              <el-table-column
                :label="aitem.c_name"
                align="center"
                :prop="aitem.name"
                show-overflow-tooltip
              />
            </div>
            <el-table-column
              label="操作"
              align="center"
              width="1px"
            ></el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <Empty v-if="expertArr.length == 0"></Empty>
      <!-- 填空题列表数据 -->
      <div class="fill_list" v-if="blanksList.length > 0">
        <!-- 按钮 -->
        <el-row class="mb8 flex_end" :gutter="10">
          <el-col :span="1.5" class="ml5">
            <el-button type="primary" size="mini" @click="customBlanksAdd"
              >自定义表头</el-button
            >
          </el-col>
          <el-col :span="1.5" class="ml5">
            <el-button type="primary" size="mini" @click="handleBlanksExport"
              >导出填空题明细</el-button
            >
          </el-col>
        </el-row>
        <SelectDetailList
          :blanksList="blanksList"
          :blanksSpheader="blanksSpheader"
          :blanksHeader="blanksHeader"
        ></SelectDetailList>
      </div>
      <!-- <Empty v-else></Empty> -->
    </section>
    <!-- 自定义表头dialog -->
    <CustomHeaderDialog
      ref="childCustomHeader"
      @handleAnswerDetails="SatisfactionListFn"
    ></CustomHeaderDialog>
  </div>
</template>

<script>
import {
  ExportBaseData,
  SatisfactionList,
  SatisfactionListExport,
  ExpertStatistics,
  ExpertList,
  SelectQuestionDetail,
  SelectDetailExport,
  SelectDetailList,
  FillQuestionDetailExport,
  ExpertFaceList,
} from "@/api/projectAdministrator";
export default {
  data() {
    return {
      baseData: {}, // 专家基本数据
      userData: {}, // 专家信息
      class_id: "",
      expertAvgList: [], // 满意度统计列表
      expertAvgHeader: [], // 满意度统计表头
      expertArr: [], // 专家列表
      postList: [], // （选择题）详细列表
      headerList: [], // （选择题）详细表头
      blanksList: [], // （填空题）详细列表
      blanksHeader: [], //（填空题）详细列表头
      blanksSpheader: [], //（填空题）详细表头
      faceList: [], //面授课列表
      activeName: "",
    };
  },
  methods: {
    // 导出填空题明细
    handleBlanksExport() {
      if (this.blanksList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }
      FillQuestionDetailExport({
        class_id: this.class_id,
        expert_id: this.activeName,
      }).then((res) => {
        saveAs(res, "填空题明细.xls");
      });
    },
    // 填空题明细自定义表头
    customBlanksAdd() {
      this.$refs.childCustomHeader.operationDialog(
        this.class_id,
        6,
        this.SelectDetailListFn,
        this.activeName
      );
    },

    // 专家满意度导出选择题明细
    handleExport() {
      if (this.postList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }

      SelectDetailExport({
        class_id: this.class_id,
        expert_id: this.activeName,
      }).then((res) => {
        saveAs(res, "选择题明细.xls");
      });
    },
    // 专家满意度明细自定义表头
    customAdd() {
      this.$refs.childCustomHeader.operationDialog(
        this.class_id,
        5,
        this.SelectQuestionDetailFn,
        this.activeName
      );
    },
    //
    handleClick(val) {
      this.activeName = val.name;
      // 专家个人统计
      this.ExpertStatisticsFn(val.name);
      // （选择题）详细
      this.SelectQuestionDetailFn(val.name);
      //（填空题）详细列表
      this.SelectDetailListFn(this.activeName);
      // 面授课列表
      this.expertFaceListFn()
    },
    // 导出
    handleAvgExport() {
      if (this.expertAvgList.length === 0) {
        this.messageTips("暂无导出数据", "warning");
        return false;
      }
      SatisfactionListExport({ class_id: this.class_id }).then((res) => {
        saveAs(res, "专家满意度统计列表.xls");
      });
    },
    // 自定义表头
    customExpertAdd() {
      this.$refs.childCustomHeader.operationDialog(
        this.class_id,
        4,
        this.SatisfactionListFn,
        this.activeName
      );
    },
    SatisfactionListFn() {
      // 满意度统计列表
      SatisfactionList({ class_id: this.class_id }).then((res) => {
        this.expertAvgList = res.data.list;
        this.expertAvgHeader = res.data.header;
      });
    },
    // 专家个人统计
    ExpertStatisticsFn(expert_id) {
      ExpertStatistics({ class_id: this.class_id, expert_id: expert_id }).then(
        (res) => {
          this.userData = res.data;
        }
      );
    },
    // （选择题）详细
    SelectQuestionDetailFn(expert_id) {
      SelectQuestionDetail({
        class_id: this.class_id,
        expert_id: expert_id,
      }).then((res) => {
        this.postList = res.data.list;
        this.headerList = res.data.header;
      });
    },
    //（填空题）详细列表
    SelectDetailListFn(expert_id) {
      SelectDetailList({
        class_id: this.class_id,
        expert_id: expert_id,
      }).then((res) => {
        this.blanksList = res.data.list;
        this.blanksHeader = res.data.header;
        this.blanksSpheader = res.data.spheader;
      });
    },

    // 面授课列表
    expertFaceListFn() {
      ExpertFaceList({
        class_id: this.class_id,
        expert_id: this.activeName,
      }).then((res) => {
        this.faceList = res.data;
      });
    },

    createFn() {
      let class_id = sessionStorage.getItem("class_id");
      if (class_id) {
        this.class_id = class_id;
      }
      // 专家基本数据
      ExportBaseData({ class_id: this.class_id }).then((res) => {
        this.baseData = res.data;
      });
      // 满意度统计列表
      this.SatisfactionListFn();
      // 专家列表
      ExpertList({ class_id: this.class_id }).then((res) => {
        this.expertArr = res.data;
        // 默认选中第一个
        if (this.expertArr.length > 0) {
          this.activeName = this.expertArr[0].idnum;
          // 专家个人统计
          this.ExpertStatisticsFn(this.activeName);
          // （选择题）详细
          this.SelectQuestionDetailFn(this.activeName);
          //（填空题）详细列表
          this.SelectDetailListFn(this.activeName);
          // 面授课列表
          this.expertFaceListFn()
        }
      });
    },
  },
  created() {
    this.createFn();
  },
};
</script>
 
<style lang = "less" scoped>
.expert_report {
}
</style>